var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-page",class:( _obj = {}, _obj[_vm.STATE_CLASSES.VISIBLE] = _vm.visible, _obj )},[_c('div',{staticClass:"loading-page__content"},[_c('figure',{staticClass:"loading-page__icon"},[_c('loading-icon',{attrs:{"type":"dots","color":_vm.iconColor}})],1),_c('span',{staticClass:"loading-page__message"},[_vm._v(" "+_vm._s(_vm.message)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }